import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['select', 'option', 'field', 'checkbox']
  
  connect() {
    this.toggle()
  }
  
  toggle() {
    const selectedOption = this.selectTarget.options[this.selectTarget.selectedIndex]
    const taxDeductibleOption = selectedOption.dataset.taxDeductible
    
    if (taxDeductibleOption == 'true') {
      this.fieldTarget.classList.remove('hide')
    } else {
      this.fieldTarget.classList.add('hide')
      this.uncheck()
    }
  }
  
  uncheck() {
    if (this.hasCheckboxTarget) { this.checkboxTarget.checked = false }
  }
  
}